import { email, phone, url, multiLink } from './Regex';

export const inputDictionary = {
  email,
  tel: phone,
  url,
  multiLink,
};

const fileTypes = ['.mp4', '.mov', '.flv', '.mpeg', '.wmv', '.m4v', '.avi', '.mkv', '.mpg'];

// 2 GB
const maxFileSize = 2_147_483_648;

export const validateVideoInput = (file: { name: string; size: number }) => {
  const extension = file.name.substring(file.name.lastIndexOf('.'));
  if (!fileTypes.includes(extension.toLowerCase())) {
    throw new Error(`Video type not recognized: ${extension}`);
  }
  if (file.size > maxFileSize) {
    throw new Error('Video size too large.');
  }
};

/**
 * Checks if the provided value is a valid string or null.
 * @param value The value to validate.
 * @param property Used in the error string to help indicate which property the value is
 *     associated with.
 * @throws {Error} Thrown if the value does not validate.
 */
export function validateStringNotEmpty(value: string, property = '') {
  if (value !== null && (typeof value !== 'string' || value === '' || /^\s+$/.test(value))) {
    throw new Error(
      `Unexpected value${property ? ` passed to ${property}` : ''}. Should be a string or null.`,
    );
  }
}

/**
 * Checks if the provided value is a valid string, valid URL, or null.
 * @param value The value to validate.
 * @param property Used in the error string to help indicate which property the value is
 *     associated with.
 * @throws {Error} Thrown if the value does not validate.
 */
export function validateStringNotEmptyOrIsURL(value: string | URL, property = '') {
  if (value instanceof URL) {
    return;
  }

  validateStringNotEmpty(value, property);
}
